// extracted by mini-css-extract-plugin
export default {"main":"XTv9R","label":"NVgVF","select":"VGGHx"};